import { listIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { ListPage } from "../lists/list-page.tsx";
import { loadList } from "../lists/loaders.ts";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { RecordPending } from "../tasks/pending.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/lists/$id");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id } = route.useParams();
  return viewer === null ? <NoAccessPage /> : <ListPage viewer={viewer} listId={id} />;
};

export const Route = createFileRoute("/_app/lists/$id")({
  params: {
    parse: ({ id }) => ({ id: parameterOrNotFound(listIdSchema, id) }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => loadList(context.data, params.id),
  pendingComponent: () => <RecordPending kind="list" />,
  component: Page,
});
